package com.demo.portfolio_demo.utils

import com.varabyte.kobweb.compose.ui.graphics.Color

object Res {
    object Images {
        const val BACKGROUND_CIRCLES = "images/background_circles.svg"
        const val PORTAL_STAR = "images/portal_star.svg"
        const val NAVIGATION_ARROW = "images/Navigation_Arrow.svg"
        const val CUSTOM_CURSOR_DARK = "images/Custom_Cursor_Dark.svg"
        const val CUSTOM_CURSOR_LIGHT = "images/Custom_Cursor_Light.svg"
//        const val MY_IMAGE = "images/My Image.jpg"
        const val MY_IMAGE = "images/My Image 2.png"
        const val MY_IMAGE_3 = "images/My Image 3.jpg"


        // Socials
        const val BEHANCE = "images/Socials/behance.svg"
        const val GITHUB = "images/Socials/github.svg"
        const val GITHUB_FILLED = "images/Socials/github-filled.svg"
        const val LINKEDIN = "images/Socials/linkedin.svg"
        const val MEDIUM = "images/Socials/medium.svg"
        const val TWITTER_X = "images/Socials/twitter-x.svg"
        const val TUMBLR_ROUND = "images/Socials/tumblr-round.svg"
        const val TUMBLR_NAME = "images/Socials/tumblr-name.svg"
        const val TUMBLR_LETTER = "images/Socials/tumblr-letter.svg"
        const val FACEBOOK = "images/Socials/facebook.svg"

        // Co-Activities
        const val CO_ACTIVITY_IMAGE_1 = "images/Co-Activities/Co Activity 01.jpg"
        const val CO_ACTIVITY_IMAGE_2 = "images/Co-Activities/Co Activity 02.jpg"
        const val CO_ACTIVITY_IMAGE_3 = "images/Co-Activities/Co Activity 03.jpg"
        const val CO_ACTIVITY_IMAGE_4 = "images/Co-Activities/Co Activity 04.jpg"
        const val CO_ACTIVITY_IMAGE_5 = "images/Co-Activities/Co Activity 05.jpg"
        const val CO_ACTIVITY_IMAGE_6 = "images/Co-Activities/Co Activity 06.jpg"

        // Photographs
        const val IMAGE_1 = "images/Photographs/Image 1.jpg"
        const val IMAGE_2 = "images/Photographs/Image 2.jpg"
        const val IMAGE_3 = "images/Photographs/Image 3.jpg"
        const val IMAGE_4 = "images/Photographs/Image 4.jpg"
        const val IMAGE_5 = "images/Photographs/Image 5.jpg"
        const val IMAGE_6 = "images/Photographs/Image 6.jpg"
        const val IMAGE_7 = "images/Photographs/Image 7.jpg"
        const val IMAGE_8 = "images/Photographs/Image 8.jpg"
        const val IMAGE_9 = "images/Photographs/Image 9.jpg"
        const val IMAGE_10 = "images/Photographs/Image 10.jpg"
        const val IMAGE_11 = "images/Photographs/Image 11.jpg"
        const val IMAGE_12 = "images/Photographs/Image 12.jpg"

        // Writings
        const val WRITING_IMAGE_01 = "images/Writings/Writing Image 1.jpeg"
        const val WRITING_IMAGE_02 = "images/Writings/Writing Image 2.jpeg"
        const val WRITING_IMAGE_03 = "images/Writings/Writing Image 3.jpeg"
        const val WRITING_IMAGE_04 = "images/Writings/Writing Image 4.jpeg"
    }

    object Fonts {
        const val Space_Grotesk = "Space Grotesk"
        const val Tauri = "Tauri"
        const val DM_SANS = "DM Sans"
    }

    object Colors {
        val FOOTER_COLOR_LIGHT = Color.Companion.rgb(0xEBEBEB)
//        val FOOTER_COLOR_LIGHT = Color.Companion.rgb(0xF1F1F1)
        val FOOTER_COLOR_DARK = Color.Companion.rgb(0x0D0D0D)
        val GLASS_BOX_BORDER_COLOR_LIGHT = Color.Companion.rgb(0xE9E9E9)
        val GLASS_BOX_BORDER_COLOR_DARK = Color.Companion.rgb(0x4E4E4E)
        val DARK_GRAY_TEXT_COLOR = Color.Companion.rgb(0x7B7B7B)
    }
}